import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Button,
    FormHelperText
} from '@mui/material';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';

export const TimesheetRefuse = (props) => {
    const { setOpenLoadingSimpleBackdrop, open, timesheetId, mission_planning_id, mission_planning_agenda_id, onClose } = props;
    const [refusFormValues, setRefusFormValues] = useState({
        timesheetId: null,
        observation: "",
    });
    const [error, setError] = useState(false);
    const [errorSubmitted, setErrorSubmitted] = useState(false);

    useEffect(() => {
        setRefusFormValues((prevValues) => ({
            ...prevValues,
            timesheetId: timesheetId,
        }));
    }
    , [timesheetId]);
    const handleRefuseTimesheet = async () => {
        if (refusFormValues.observation.trim() === "") {
            setError(true);
            return;
        }

        const result = await TimeSheetMissionService.refuseTimesheetMission(
            refusFormValues.timesheetId,
            refusFormValues.observation,
            mission_planning_id,
            mission_planning_agenda_id
        );
        if (result && result.status) {
            setOpenLoadingSimpleBackdrop(false);
            onClose();
        } else {
            setErrorSubmitted(true);
        }
    };
console.log("TimesheetRefuse observation:", timesheetId);
  return (
     <Dialog
        open={open}
        onClose={() => setOpenLoadingSimpleBackdrop(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
          Refus de timesheet
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
           <label>Êtes-vous sûr de vouloir refuser ce timesheet ?</label>
            <br />
           <label>Observation :</label>
            <TextField
              autoFocus
              margin="dense"
              id="reason"
              label="Raison du refus"
              type="text"
              rows={10}
              fullWidth
              variant="outlined"
              error={error}
              value={refusFormValues.observation || ""}
              onChange={(e) => {
                setError(false);
                setRefusFormValues({
                  ...refusFormValues,
                  observation: e.target.value,
                })
              }
              } 
            />
            {(error || errorSubmitted) && (
              <FormHelperText
                error
                sx={{ marginLeft: "400px", fontSize: "16px" }}
              >
              {error ? "Veuillez remplir le champ Raison du refus" : "Une erreur est survenue lors du refus du timesheet. Veuillez réessayer."}
              </FormHelperText>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="error"
            variant="contained"
          >
            Annuler
          </Button>
          <Button
            onClick={handleRefuseTimesheet}
            color="primary"
            variant="contained"
          >
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>

    );
};

export default TimesheetRefuse;